import { useIntl } from 'react-intl';
import { useEffect, useState } from 'react';
import { selectBrokerProducts } from '../../../store/selectors/brokerProducts';
import { COMPLETED } from '../../../store/actions/types';
import { useSelector } from 'react-redux';
import Grid from './Products/Grid';
import '../../../styles/integrations.scss';
import Notification from '../../../components/Utils/Notification';
import { useHistory } from 'react-router-dom';
import { slugify } from './Products/helpers';

const Integrations = () => {
  const history = useHistory();
  const [hasUserProducts, setHasUserProducts] = useState(false);
  const { formatMessage } = useIntl();
  const brokerProducts = useSelector(selectBrokerProducts);

  const isBrokerProductsCompleted = brokerProducts.status === COMPLETED;

  const setProductsDetails = () => {
    try {
      const hasOneProduct = brokerProducts?.data.length === 1;
      const hasMoreProducts = brokerProducts?.data.length > 0;

      if (hasOneProduct) {
        const name = brokerProducts?.data[0].name;
        history.push(`/integrations/${slugify(name)}/details?product=${name}`);
      } else {
        setHasUserProducts(hasMoreProducts);
      }
    } catch (error) {
      Notification({
        type: 'error',
        text: formatMessage({
          id: 'Something went wrong, try again later',
        }),
      }).show();
    }
  };

  useEffect(() => {
    isBrokerProductsCompleted ? setProductsDetails() : undefined;
  }, [isBrokerProductsCompleted]);

  return <div className='integrations'>{hasUserProducts ? <Grid /> : null}</div>;
};

export default Integrations;
